export const ROULETTE_SPEED = {
  fast: 3,
  normal: 8,
  battle: 7
};
